// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';
// local
// import t from 'app/utils/i18n';
// stylesheets
import styles from './Notification.module.scss';

class Notification extends Component {
  render() {
    const { isError, message } = this.props;
    let header = null;
    let content = null;
    let list = null;
    if (isError) {
      if (!message) {
        return null;
      }
      if (message.length > 1) {
        header = 'Alguns erros foram encontrados:';
        list = message.map(item => item.key);
      } else {
        const item = message[0];
        content = item.key;
      }
    } else {
      content = message;
    }

    return (
      <Message
        className={message ? styles.notificationShow : styles.notification}
        header={header}
        error={isError}
        content={content}
        list={list}
        onDismiss={this.handleDismiss}
      />
    );
  }
}

Notification.propTypes = {
  isError: PropTypes.bool,
  message: PropTypes.any
};

export default Notification;
